import { ChevronDown } from 'lucide-react';
import { Link } from '@/router';
import { FAQS } from '@/data/site';
import { SongketDivider } from '@/components/Motifs';

export default function Faq() {
  return (
    <div data-testid="faq-page">
      <section className="border-b border-stone-200 bg-cream-2">
        <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 md:py-20">
          <nav className="text-xs font-semibold uppercase tracking-[0.2em] text-stone-500" aria-label="Breadcrumb" data-testid="faq-breadcrumb">
            <Link to="/" className="text-crimson hover:underline">Beranda</Link>
            <span className="mx-2" aria-hidden="true">›</span>
            <span aria-current="page">FAQ</span>
          </nav>
          <h1 className="mt-4 font-display text-4xl font-bold tracking-tight text-charcoal sm:text-5xl">
            Pertanyaan yang Sering Diajukan
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-stone-600 sm:text-lg">
            Semua yang perlu Anda ketahui sebelum duduk di meja hidang — dari cara penyajian
            hingga tingkat kepedasan masakan Padang.
          </p>
        </div>
        <SongketDivider />
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 md:py-20">
        <div className="space-y-4">
          {FAQS.map((f, i) => (
            <details
              key={f.q}
              data-testid={`faq-item-${i}`}
              className="group rounded-2xl border border-stone-200 bg-white shadow-sm transition-shadow duration-300 open:shadow-md"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 p-6 text-base font-bold text-charcoal transition-colors duration-200 hover:text-crimson [&::-webkit-details-marker]:hidden">
                <h2 className="text-base font-bold">{f.q}</h2>
                <ChevronDown className="h-5 w-5 shrink-0 text-turmeric transition-transform duration-300 group-open:rotate-180" aria-hidden="true" />
              </summary>
              <div className="px-6 pb-6 text-sm leading-relaxed text-stone-600">{f.a}</div>
            </details>
          ))}
        </div>

        <div className="mt-14 rounded-3xl border border-turmeric/40 bg-turmeric-soft p-8" data-testid="faq-cta-section">
          <h2 className="font-display text-2xl font-bold text-charcoal">Masih Penasaran?</h2>
          <p className="mt-2 text-sm leading-relaxed text-stone-700">
            Cara terbaik memahami masakan Padang adalah mencicipinya. Mulai dengan menjelajahi
            daftar hidangan kami.
          </p>
          <Link
            to="/menu/"
            data-testid="faq-cta-menu"
            className="mt-5 inline-flex items-center rounded-full bg-crimson px-6 py-3 text-sm font-bold text-santan transition-colors duration-200 hover:bg-crimson-dark"
          >
            Jelajahi Daftar Hidangan
          </Link>
        </div>
      </section>
    </div>
  );
}
